export default "__VITE_ASSET__DSXKrher__"